import type { ReactNode } from 'react';

const SkeletonHotel = () => (
    <article className="card result-list-item">
        <div className="image-container result-list-image skeleton-screen" />
        <div className="result-list-item-details">
            <div>
                <div className="u-mb8 u-pt16 u-pb8 u-size1of2 skeleton-screen" />
                <div className="u-mb8 u-pv16 u-size1of1 skeleton-screen" />
            </div>
            <div>
                <div className="u-mb8 u-pt16 u-pb8 u-size2of3 skeleton-screen" />
                <div className="u-pt16 u-pb8 u-size3of3 skeleton-screen" />
            </div>
        </div>
        <div className="result-list-item-price">
            <div className="u-size1of2 u-pv8 u-mb4 skeleton-screen" />
            <div className="u-size2of3 u-pt16 u-pb8 u-mb16 skeleton-screen" />
            <div className="u-size2of3 u-pv8 u-mb4 skeleton-screen" />
            <div className="u-size1of2 u-pt16 u-pb8 u-mb4 skeleton-screen" />
        </div>
    </article>
);

export const listOfSkeletons = (size: number): ReactNode[] => {
    if (size <= 0) {
        return [];
    }

    // biome-ignore lint/suspicious/noArrayIndexKey: index isn't useless here
    return [...new Array(size).keys()].map((_, index) => <SkeletonHotel key={`skeletonHotel-${index}`} />);
};
